
import Vue from 'vue';

interface Props {
  customerHasAccess: boolean;
}

interface Methods {
  setActivePage: (page: string) => void;
}
export default Vue.extend<unknown, Methods, unknown, Props>({
  props: {
    customerHasAccess: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    setActivePage(page) {
      this.$emit('set-active-page', page);
    },
  },
});
